/* Step 03: phone menu navigation and desktop Shop link, Oct 2026.
   The shared overlay core owns the drawer's lifecycle; Dawn and pbs-ux.js
   continue to own the desktop details toggle and hover behaviour. */
(function () {
  'use strict';

  var menuBound = false;

  function menuPhone() {
    if (menuBound) return;
    menuBound = true;

    // Delegate because the overlay core moves/replaces the drawer in the editor.
    document.addEventListener('click', function (event) {
      if (!(event.target instanceof Element)) return;
      var link = event.target.closest('#pbs-menu a[href]');
      if (!link) return;
      if (window.PBSPhone && window.PBSPhone.overlay) window.PBSPhone.overlay.close();
    });
  }

  function shopLink() {
    document.querySelectorAll('.header__inline-menu details.mega-menu > summary').forEach(function (summary) {
      if (summary.dataset.pbsShopLink) return;
      summary.dataset.pbsShopLink = '1';

      summary.addEventListener('focus', function (event) {
        var details = summary.parentElement;
        // Enter the visible panel on Tab. Dawn returns focus here on Escape;
        // moving back from inside this details must leave that panel closed.
        if (details.contains(event.relatedTarget) || !summary.matches(':focus-visible')
          || !window.matchMedia('(min-width: 821px)').matches) return;
        details.open = true;
        summary.setAttribute('aria-expanded', 'true');
      });

      summary.addEventListener('click', function (event) {
        // Large-screen keyboard activation keeps Dawn's details toggle, and
        // large touch screens keep tap-to-open. Compact nav has no panel, so
        // both keyboard and pointer activation follow the Shop destination.
        if (event.defaultPrevented || event.button !== 0
          || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey
          || !window.matchMedia('(min-width: 750px)').matches) return;
        var compact = window.matchMedia('(max-width: 820px)').matches;
        if (!(event.detail > 0) && !(compact && event.detail === 0)) return;
        if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches
          && !compact) return;

        // Read the rendered link first so localized collection URLs survive.
        var allProducts = summary.parentElement.querySelector('a[href$="/collections/all"]');
        var url = allProducts ? allProducts.href
          : (window.routes && window.routes.all_products_collection_url) || '/collections/all';
        event.preventDefault();
        window.location.href = url;
      });
    });
  }

  function init() {
    menuPhone();
    shopLink();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', init);
})();
